(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hallo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var state = {};
    function init(id, total, speed) {
      state[id] = { current: 0, total: total };
      autoplay(id, speed);
    }
    function update(id) {
      var s = state[id];
      var track = document.getElementById('dahly-track-' + id);
      if (track) track.style.transform = 'translateX(-' + s.current * 100 + '%)';
      var dots = document.querySelectorAll('#dahly-dots-' + id + ' .dahly-hero__dot');
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === s.current); });
    }
    function autoplay(id, speed) {
      setInterval(function () {
        if (!state[id]) return;
        state[id].current = (state[id].current + 1) % state[id].total;
        update(id);
      }, speed);
    }
    window.dahlyHeroGoTo = function (id, index) {
      if (!state[id]) return;
      state[id].current = index;
      update(id);
    };
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('[data-testid="dahly-hero-slideshow"]').forEach(function (el) {
        var id = el.querySelector('.dahly-hero__track').id.replace('dahly-track-', '');
        var total = el.querySelectorAll('.dahly-hero__slide').length;
        var speed = parseInt(el.getAttribute('data-autoplay'), 10) || 5000;
        if (total > 1) init(id, total, speed);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
